import type { DeviceModel } from '../../types/deviceModel';
import { portRow, powerPort, simpleLayout } from './layoutHelpers';
import type { MultiFaceLayout } from '../../types';

const atOut = {
  standards: ['802.3af', '802.3at'] as const,
  perPortMaxWatts: 15.4,
  modeDefault: 'auto' as const,
};

export const us16PoeModel: DeviceModel = {
  equipmentId: 'ubnt-us-16-poe',
  selfDrawWatts: 20,
  powerInputs: [{ id: 'ac', kind: 'ac', portNumber: 1, face: 'back', maxWatts: 150 }],
  layout: {
    multiFace: {
      defaultFace: 'front',
      faces: {
        front: simpleLayout(
          [
            ...portRow({
              count: 8,
              startNumber: 1,
              kind: 'rj45',
              speedsMbps: [10, 100, 1000],
              poeOut: { ...atOut, standards: [...atOut.standards] },
              y: 12,
            }),
            ...portRow({
              count: 8,
              startNumber: 9,
              kind: 'rj45',
              speedsMbps: [10, 100, 1000],
              y: 40,
              flipped: true,
            }),
          ],
          240,
          80
        ),
        back: simpleLayout(
          [powerPort({ number: 1, kind: 'ac', label: 'AC in', x: 12, y: 20 })],
          140,
          70
        ),
      },
    } as MultiFaceLayout,
  },
};
